import SectionMapWithListings from './SectionMapWithListings';

export default SectionMapWithListings;
